import { tempConfigData } from "../../app/state/state.js";
import { createSelectControl } from "../../shared/ui/controls/selectControl.js";
import { escapeHTML } from "../../shared/utils/contentUtils.js";

function attrValue(value = "") {
    return escapeHTML(String(value ?? ""));
}

function getClosedTaskStatusOptions() {
    return (tempConfigData?.taskStatus || [])
        .filter((status) => status?.isClosed === true)
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .map((status) => ({
            value: status.id,
            label: status.name || status.id || "",
        }));
}

/**
 * Mounts Task Settings custom controls.
 * @param {HTMLElement} container Settings tab container.
 * @returns {void}
 */
export function bindTaskSettingsControls(container) {
    const quickCloseRoot = container.querySelector(
        "[data-task-quick-close-status-control]",
    );
    if (!quickCloseRoot) {return;}

    createSelectControl({
        root: quickCloseRoot,
        accessibleName: "Quick close status",
        value: tempConfigData?.taskQuickCloseStatusId || "",
        options: getClosedTaskStatusOptions(),
        clearable: true,
        placeholder: "Disabled",
        emptyMessage: "No closed statuses configured.",
        onChange: (value) => {
            tempConfigData.taskQuickCloseStatusId = value || null;
            quickCloseRoot.dispatchEvent(new Event("input", { bubbles: true }));
        },
    });
}

/**
 * Renders task-specific Settings configuration controls.
 * @returns {string} Task settings HTML.
 */
export function renderTaskSettings() {
    return `
        <div class="bg-white p-6 rounded-lg shadow-md">
            <h4 class="text-lg font-semibold mb-4 border-b pb-2">Task Configuration</h4>
            <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
                <div class="max-w-md">
                    <label class="block font-medium mb-2">Minimum visible horizon (days)</label>
                    <input type="number" min="0" step="1" class="w-full p-2 border rounded" data-config-key="minTaskVisibilityHorizonDays" value="${attrValue(tempConfigData?.minTaskVisibilityHorizonDays ?? "")}" placeholder="No minimum">
                    <p class="settings-helper-text">Users can hide far-future tasks on the main Tasks page, but entered values cannot be lower than this minimum. Leave blank to allow any value, including blank.</p>
                </div>
                <div class="max-w-md">
                    <label class="block font-medium mb-2">Quick close status</label>
                    <div data-task-quick-close-status-control></div>
                    <p class="settings-helper-text">Controls which closed task status is applied by the quick close action on task cards, grouped task rows, and embedded task rows. Leave disabled to hide quick close.</p>
                </div>
            </div>
        </div>
    `;
}
